import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from "react-router-dom";
import { DataProvider } from "./context/DataContext";
import Home from "./components/Home";
import Matchs from "./components/Matchs";
import Joueurs from "./components/Joueurs";
import Contact from "./components/Contact";
import Mentions from "./components/Mentions-Legales";
import NotFound from "./components/NotFound";
import Footer from "./components/Footer";
import logo from "./assets/img/svg/logo.svg";
import { ScrollToAnchor } from "./utils/utils";

function AppShell() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { pathname } = useLocation();

  // Le header est transparent (par-dessus le hero) uniquement sur l'accueil ;
  // ailleurs il prend un fond plein. Piloté par la route, pas par le DOM.
  const isHome = pathname === "/";

  useEffect(() => {
    document.body.classList.toggle("no-scroll", isCollapsed);
    return () => document.body.classList.remove("no-scroll");
  }, [isCollapsed]);

  const toggleCollapse = () => setIsCollapsed((v) => !v);
  const closeCollapse = () => setIsCollapsed(false);

  return (
    <div className="App d-flex flex-column min-vh-100">
      <header className="App-header">
        <nav
          id="navbar"
          className={`navbar navbar-expand-lg navbar-light${isHome ? "" : " page"}`}
        >
          <Link className="navbar-brand" to="/" onClick={closeCollapse}>
            <img
              src={logo}
              alt="Tennis de Table Briançon"
              width="190"
              height="122"
              className="navbar-logo"
              decoding="async"
            />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleCollapse}
            aria-controls="navbarSupportedContent"
            aria-expanded={isCollapsed}
            aria-label="Toggle navigation"
          >
            <span className="nv-icon"></span>
            <span className="nv-icon"></span>
            <span className="nv-icon"></span>
          </button>
          <div
            className={`navbar-collapse ${isCollapsed ? "show" : ""}`}
            id="navbarSupportedContent"
          >
            <button
              className="close-button"
              onClick={toggleCollapse}
              aria-label="Close"
            ></button>
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li>
                <Link className="navbar-brand-collapse" to="/" onClick={closeCollapse}>
                  <img
                    src={logo}
                    alt="Tennis de Table Briançon"
                    width="190"
                    height="122"
                    className="navbar-logo"
                    decoding="async"
                    loading="lazy"
                  />
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="./#infos-pratiques" onClick={closeCollapse}>
                  Infos pratiques
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/joueurs" onClick={closeCollapse}>
                  Joueurs
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/matchs" onClick={closeCollapse}>
                  Matchs
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact" onClick={closeCollapse}>
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </header>
      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/matchs" element={<Matchs />} />
          <Route path="/joueurs" element={<Joueurs />} />
          <Route path="/mentions-legales" element={<Mentions />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <DataProvider>
      <Router>
        <ScrollToAnchor />
        <AppShell />
      </Router>
    </DataProvider>
  );
}

export default App;
